import React from "react";
import { LabelProps } from "./props";

/**
 * Primary UI component for user interaction
 */
const Label = ({ text, isFor, ...theme }: LabelProps): React.JSX.Element => {
  return (
    <label
      className={"vcl-label vcl-label-primary"}
      {...theme}
      htmlFor={isFor}
      id={`${isFor}-label`}
    >
      {text}
    </label>
  );
};

export default Label;
